/**
 * Objeto no formato esperado pelo menu lateral (reloadMenu) e pela tela de demo.
 * packagename sem ".light" para não acionar restrições PRO-only nas rotas.
 */
export const demoMobile = {
  uid: 0,
  plan_id: 1,
  panel_version: 1,
  packagename: 'com.demo.wspy',
  alias: 'Celular de demonstração',
  apkversion: '9.99.0',
  count: {
    whatsapp: 186,
    whatsappaudio: 34,
    whatsappcall: 12,
    instagram_chats: 72,
    telegram: 41,
    app: 48,
    call: 89,
    keylogger: 1204,
    contact: 312,
    webhistory: 876,
    websearch: 145,
    sms: 67,
    location: 240,
    safezone: 3,
    photogallery: 92,
    remotephoto: 8,
    microphone: 15,
    messenger: 0,
    messengeraudio: 0
  },
  permission: {
    accessibility: true,
    files: true,
    location: true,
    calls: true,
    sms: true,
    contacts: true,
    remotephoto: true,
    microphone: true
  },
  licence: {
    until: '2030-12-31'
  }
}

/** Banners do swiper no mesmo formato simplificado da API (campo content = HTML). */
export function getDemoBanners(locale) {
  const en = locale === 'en'
  return [
    {
      id: 1,
      content: en
        ? '<div class="demo-swiper-banner p-8 rounded-lg" style="background:linear-gradient(120deg,#6b46c1,#9f7aea);color:#fff;min-height:140px"><h3 class="text-white mb-2">Panel demo</h3><p class="mb-0 opacity-90">Everything here is fictional. Use the sidebar as usual.</p></div>'
        : '<div class="demo-swiper-banner p-8 rounded-lg" style="background:linear-gradient(120deg,#6b46c1,#9f7aea);color:#fff;min-height:140px"><h3 class="text-white mb-2">Demonstração do painel</h3><p class="mb-0 opacity-90">Todos os dados exibidos aqui são fictícios. Explore o menu lateral normalmente.</p></div>'
    },
    {
      id: 2,
      content: en
        ? '<div class="demo-swiper-banner p-8 rounded-lg" style="background:linear-gradient(120deg,#0f766e,#14b8a6);color:#fff;min-height:140px"><h3 class="text-white mb-2">Tip</h3><p class="mb-0 opacity-90">The counts and tiles below mimic the real panel after app sync.</p></div>'
        : '<div class="demo-swiper-banner p-8 rounded-lg" style="background:linear-gradient(120deg,#0f766e,#14b8a6);color:#fff;min-height:140px"><h3 class="text-white mb-2">Dica</h3><p class="mb-0 opacity-90">As contagens e cards abaixo imitam o painel real após a sincronização do aplicativo.</p></div>'
    }
  ]
}

/**
 * Payload completo para `DashboardMobile` (mesmos campos usados no template + Map.vue).
 */
export function getDemoDashboardDevice(locale) {
  const now = new Date()
  const iso = now.toISOString()
  const en = locale === 'en'
  return {
    ...demoMobile,
    alias: en ? 'Demo handset' : demoMobile.alias,
    device: en ? 'SM-G998B (simulated)' : 'SM-G998B (simulado)',
    battery: 64,
    network: 'WIFI',
    wifi_ssid: 'Casa_5G',
    phone: '+55 11 98888-7766',
    provider: 'Vivo',
    gps: 1,
    latitude: -23.561414,
    longitude: -46.655881,
    location_update_at: iso,
    updated_at: iso,
    can_switch_panel: 0,
    licence: {
      until: '2030-12-31'
    }
  }
}
